"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RocheToggle = void 0;

require("core-js/modules/es.date.to-string.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

var _react = _interopRequireDefault(require("react"));

var _clsx4 = _interopRequireDefault(require("clsx"));

var _ButtonBase = _interopRequireDefault(require("@material-ui/core/ButtonBase"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _core = require("../core");

var _utils = require("../utils");

var _toggle = require("./toggle.style");

var _excluded = ["label", "icon", "elevation", "selected", "disableFocusRipple", "classes", "onClick"],
    _excluded2 = ["icon", "label", "selected"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Toggle buttons can be used to group related options. To emphasize groups of related toggle buttons, a group
 * should share a common container.
 */
var RocheToggle = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _icon$props, _clsx, _clsx2;

  var label = props.label,
      icon = props.icon,
      elevation = props.elevation,
      selected = props.selected,
      disableFocusRipple = props.disableFocusRipple,
      classes = props.classes,
      onClick = props.onClick,
      restProps = _objectWithoutProperties(props, _excluded);

  var _mergeClasses = (0, _utils.mergeClasses)((0, _toggle.useStyles)({
    elevation: elevation,
    label: label
  }), classes),
      iconClass = _mergeClasses.icon,
      labelClass = _mergeClasses.label,
      selectedClass = _mergeClasses.selected,
      innerClases = _objectWithoutProperties(_mergeClasses, _excluded2);

  var iconClassname = (0, _clsx4["default"])(iconClass, icon === null || icon === void 0 ? void 0 : (_icon$props = icon.props) === null || _icon$props === void 0 ? void 0 : _icon$props.className, (_clsx = {}, _defineProperty(_clsx, innerClases.disabled, restProps.disabled), _defineProperty(_clsx, selectedClass, selected), _clsx));
  var labelClassname = (0, _clsx4["default"])(labelClass, (_clsx2 = {}, _defineProperty(_clsx2, innerClases.disabled, restProps.disabled), _defineProperty(_clsx2, selectedClass, selected), _clsx2));

  var handleClick = function handleClick(event) {
    onClick(event, restProps.value.toString());
  };

  return /*#__PURE__*/_react["default"].createElement(_ButtonBase["default"], _extends({
    classes: _objectSpread(_objectSpread({}, innerClases), {}, {
      root: (0, _clsx4["default"])(innerClases.root, _defineProperty({}, selectedClass, selected))
    }),
    ref: ref,
    focusRipple: !disableFocusRipple,
    onClick: handleClick
  }, restProps), label ? /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    className: labelClassname,
    component: "span",
    variant: "body1"
  }, label) : icon && /*#__PURE__*/_react["default"].cloneElement(icon, {
    className: iconClassname
  }));
});

exports.RocheToggle = RocheToggle;
RocheToggle.displayName = (0, _core.rochePrefix)('Toggle');
RocheToggle.defaultProps = {
  elevation: 2,
  disableFocusRipple: true
};
var _default = RocheToggle;
exports["default"] = _default;